import Vue from 'vue'
import VueRouter from 'vue-router'
import Reserve from '../views/ReserveView.vue'
import ReserveList from '../views/ReserveListView.vue'
import ReserveCalendar from '../views/ReserveCalendar.vue'
import Sample from '../views/SampleView.vue'
import Scheduler from '../views/SchedulerView.vue'
import Dialog from '../views/DialogView.vue'
import Staff from '../views/StaffView.vue'
import Yuukyuu from '../views/YuukyuuView.vue'
import Kyuka from '../views/KyukaView.vue'
import StaffList from '../views/StaffListView.vue'
import Patient from '../views/PatientView.vue'
import PatientList from '../views/PatientListView.vue'
import Shift from '../views/ShiftView.vue'
import Settings from '../views/SettingsView.vue'
import Login from '../views/LoginView.vue'
import FooterColor from '../views/FooterColor.vue'
import Kintai from '../views/KintaiView.vue'
import Template from '../views/TemplateList.vue'
import TemplateDetail from '../views/TemplateDetail.vue'
import Mail from '../views/MailList.vue'
import MailDetail from '../views/MailDetail.vue'
import mycolor from '@/mycolor.js';

Vue.use(VueRouter)

const routes = [
  {
    path: '/mail',
    name: 'mail',
    component: Mail
  },
  {
    // メール登録
    path: '/mail/new',
    name: 'mail_detail_new',
    component: MailDetail
  },
  {
    // メール編集
    path: '/mail/:name',
    name: 'mail_detail',
    component: MailDetail
  },
  {
    path: '/template',
    name: 'template',
    component: Template
  },
  {
    path: '/template/:name',
    name: 'template_detail',
    component: TemplateDetail
  },
  {
    path: '/kyuka',
    name: 'kyuka',
    component: Kyuka
  },
  {
    path: '/yuukyuu/:id',
    name: 'yuukyuu',
    component: Yuukyuu
  },
  {
    path: '/kintai/:id',
    name: 'kintai',
    component: Kintai
  },
  {
    path: '/kintai',
    name: 'kintai_general',
    component: Kintai
  },
  {
    path: '/sample',
    name: 'sample',
    component: Sample
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/samplesc',
    name: 'samplesc',
    component: Scheduler
  },
  {
    path: '/shift',
    name: 'shift',
    component: Shift
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings
  },
  {
    path: '/dialog',
    name: 'dialog',
    component: Dialog
  },
  {
    path: '/reserve',
    name: 'reserve',
    component: Reserve
  },
  {
    path: '/reserve/:id',
    name: 'reserve_update',
    component: Reserve
  },
  {
    path: '/reservelist',
    name: 'reservelist',
    component: ReserveList
  },
  {
    path: '/reservecalendar/:date',
    name: 'reservecalendar_specific',
    components: {
        default: ReserveCalendar,
        footer: FooterColor
    }
  },
  {
    path: '/reservecalendar',
    name: 'reservecalendar',
    components: {
        default: ReserveCalendar,
        footer: FooterColor
    }
  },
  {
    path: '/staff',
    name: 'staff',
    component: Staff
  },
  {
    path: '/staff/:id',
    name: 'staff_update',
    component: Staff
  },
  {
    path: '/stafflist',
    name: 'stafflist',
    component: StaffList
  },
  {
    path: '/patient',
    name: 'patient',
    component: Patient
  },
  {
    path: '/patient/:id',
    name: 'patient_update',
    component: Patient
  },
  {
    path: '/patientlist',
    name: 'patientlist',
    component: PatientList
  },
  {
    path: '/patientlist_search',
    name: 'patientlist_search',
    component: PatientList
  },
  {
    path: '/patientlist_search_mail',
    name: 'patientlist_search_mail',
    component: PatientList
  },
  {
    path: '/',
    name: 'home',
    components: {
        default: ReserveCalendar,
        footer: FooterColor
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router


router.beforeEach( (to, from, next) => {
  console.log('%c beforeEach: router/index.js', 'background:DeepSkyBlue;font-size:20px;');
  console.log('%c to: ', mycolor.created);
  console.log(to);
  console.log('%c from: ', mycolor.created);
  console.log(from);

  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  let loggedIn = null;

  try{
      // 単にtokenが取り出せるというだけで、tokenの有効性は確認しない. 取り出せなかったらnullが入る.
      loggedIn = JSON.parse(localStorage.getItem('user'));
  }catch(e){
      console.log(e);
  }

  console.log('%c loggedIn: '+loggedIn, mycolor.strong);


  // publicPages に該当するパスだったら認証チェックしない.
  if ( authRequired && (loggedIn==null) ) {
      // redirect to login page
      // paramsに入れることも可能.
      document.title = to.name;
      next( { name:'login', query:{from:to.name} } );
      console.log('%c after next("login")', 'background: red; font-size:20px;');
  } else {
      document.title = to.name;
      next();
  }

});
